import { useLang } from "../../context/LanguageContext";

export const Services = () => {
  const { t } = useLang();
  return (
    <section id="services" data-testid="services-section" className="py-24 lg:py-32 bg-[#F8F9FA] border-b border-[#0B1F3A]/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-6 mb-14">
          <div className="col-span-12 lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-[#D4AF37]" />
              <span className="overline">{t.services.eyebrow}</span>
            </div>
            <h2 className="font-display text-3xl lg:text-4xl font-light text-[#0B1F3A] leading-tight tracking-tight">
              {t.services.title}
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-[#0B1F3A]/70 text-base lg:text-lg leading-relaxed">{t.services.sub}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-[#0B1F3A]/15 bg-white">
          {t.services.items.map((s, i) => (
            <div
              key={s}
              data-testid={`service-${i}`}
              className="border-r border-b border-[#0B1F3A]/15 px-6 py-6 flex items-center justify-between group hover:bg-[#F8F9FA] transition-colors"
            >
              <div className="flex items-center gap-4">
                <span className="text-[10px] tracking-widest text-[#0B1F3A]/40 font-mono">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="text-[15px] font-medium text-[#0B1F3A]">{s}</span>
              </div>
              <span className="w-4 h-px bg-[#0B1F3A]/20 group-hover:bg-[#D4AF37] group-hover:w-8 transition-all" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
